import ImagePanel from './ImagePanel';
import ScorePanel from './ScorePanel';
import StageCard from './StageCard';
import { DetailPanel, ClaimsPanel } from './DetailPanels';
import './ResultsView.css';

export default function ResultsView({ data, imageUrl, onReset }) {
  const { stage1, stage2, stage3, verdict, credibility_score } = data;

  return (
    <div className="results-view">
      <div className="results-view__top">
        <ImagePanel imageUrl={imageUrl} />
        <ScorePanel score={credibility_score} verdictKey={verdict} />
      </div>

      <div className="results-view__stages">
        <StageCard
          index="01"
          title="AUTHENTICITY"
          subtitle="Is this a real photograph?"
          weight={20}
          score={stage1.confidence}
          status={stage1.is_photo ? 'PASS' : 'FAIL'}
          statusTone={stage1.is_photo ? 'positive' : 'negative'}
          rows={[
            ['Medium', stage1.medium],
            ['Confidence', `${stage1.confidence}%`],
            ['Photograph', stage1.is_photo ? 'true' : 'false'],
          ]}
          reasoning={stage1.reasoning}
        />
        {stage2 ? (
          <StageCard
            index="02"
            title="MANIPULATION"
            subtitle="Has it been altered?"
            weight={50}
            score={stage2.integrity_score}
            status={stage2.manipulated ? 'FLAGGED' : 'CLEAN'}
            statusTone={stage2.manipulated ? 'negative' : 'positive'}
            rows={[
              ['Integrity', `${stage2.integrity_score}/100`],
              ['Manipulated', stage2.manipulated ? 'true' : 'false'],
              ['Flags', stage2.flags.length ? stage2.flags.join(', ') : 'none'],
            ]}
            reasoning={stage2.reasoning}
          />
        ) : (
          <StageCard
            index="02"
            title="MANIPULATION"
            subtitle="Has it been altered?"
            weight={50}
            score={0}
            status="SKIPPED"
            statusTone="neutral"
            rows={[]}
            reasoning="This stage was not evaluated because the image did not pass the authenticity check."
          />
        )}
        {stage3 ? (
          <StageCard
            index="03"
            title="FACTUAL COHERENCE"
            subtitle="Does the context check out?"
            weight={30}
            score={stage3.factual_score}
            status={stage3.context_mismatch ? 'MISMATCH' : 'COHERENT'}
            statusTone={stage3.context_mismatch ? 'negative' : 'positive'}
            rows={[
              ['Factual score', `${stage3.factual_score}/100`],
              ['Context mismatch', stage3.context_mismatch ? 'true' : 'false'],
              ['Claims found', `${stage3.claims_found?.length ?? 0}`],
            ]}
            reasoning={stage3.reasoning}
          />
        ) : (
          <StageCard
            index="03"
            title="FACTUAL COHERENCE"
            subtitle="Does the context check out?"
            weight={30}
            score={0}
            status="SKIPPED"
            statusTone="neutral"
            rows={[]}
            reasoning="This stage was not evaluated because the image did not pass the authenticity check."
          />
        )}
      </div>

      {stage3 && (
        <div className="results-view__details">
          <DetailPanel title="SCENE DESCRIPTION" body={stage3.scene_description} />
          <DetailPanel title="VERIFICATION NOTES" body={stage3.verification_notes} />
          <ClaimsPanel claims={stage3.claims_found ?? []} />
        </div>
      )}

      <div className="results-view__actions">
        <button type="button" onClick={onReset} className="results-view__reset">
          ← ANALYZE ANOTHER IMAGE
        </button>
      </div>
    </div>
  );
}
